import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const CommandStatus = ({ name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "总状态" })}
      clearable
      options={[
        { id: 1, name: t({ defaultMessage: "成功" }) },
        { id: 2, name: t({ defaultMessage: "失败" }) },
        { id: 0, name: t({ defaultMessage: "进行中" }) }
      ]}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export default CommandStatus;
